import { IApiBaseProps, IResultResponse } from '@common/api.models';
import { createGetOptionsCustomPropsFn, createGetOptionsFn } from '@common/selectOptions.services';
import { envConfigs } from '@config/envConfigs';
import { IItemResponse, IPagedResultsV1 } from '@gcl/react-core';
import { apiServerDelete, apiServerGet, apiServerPost, apiServerPut } from '@common/axios.services';
import {
  ICreateProjectCompanyRequest,
  IProjectCompany,
  IProjectCompanyOption,
  IProjectCompanyWithRolesAndAllUserTeam,
  IUpdateProjectCompanyRequest,
} from './projectCompany.models';

export const apiRoutes = {
  projectCompanyOptions: '/Companies/Options',
  createProjectCompany: '/Companies',
  updateProjectCompany: '/Companies',
  deleteProjectCompany: '/Companies',
  getProjectCompany: '/Companies',
  checkerOptions: '/Companies/Checker/Options',
  designerOptions: '/Companies/Designer/Options',
  reviewerOptions: '/Companies/Reviewer/Options',
  distributionOptions: '/Companies/Distributions/Options',
  allCompaniesWithRolesAndUsers: '/Companies/All/WithRolesAndUsers',
};

export const getProjectCompanyOptionsAsync = createGetOptionsFn<IProjectCompanyOption>(apiRoutes.projectCompanyOptions);

export const createProjectCompanyAsync = async (
  request: ICreateProjectCompanyRequest,
): Promise<IItemResponse<IProjectCompany>> => {
  const result = await apiServerPost<IItemResponse<IProjectCompany>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.createProjectCompany}`,
    request,
  );
  return result.data;
};

export const updateProjectCompanyAsync = async (
  request: IUpdateProjectCompanyRequest,
): Promise<IItemResponse<IProjectCompany>> => {
  const result = await apiServerPut<IItemResponse<IProjectCompany>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.updateProjectCompany}/${request.id}`,
    request,
  );
  return result.data;
};

export interface IDeleteProjectCompanyProps extends IApiBaseProps {
  id: number;
}

export const deleteProjectCompanyAsync = async ({
  id,
  ...props
}: IDeleteProjectCompanyProps): Promise<IResultResponse> => {
  const result = await apiServerDelete<IResultResponse>(
    `${envConfigs.apiBaseUrl}${apiRoutes.deleteProjectCompany}/${id}`,
    {
      params: { ...props },
    },
  );
  return result.data;
};

export interface IGetProjectCompanyProps extends IApiBaseProps {
  id: number;
}

export const getProjectCompanyAsync = async ({
  id,
  ...props
}: IGetProjectCompanyProps): Promise<IItemResponse<IProjectCompany>> => {
  const result = await apiServerGet<IItemResponse<IProjectCompany>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getProjectCompany}/${id}`,
    {
      params: {
        ...props,
      },
    },
  );
  return result.data;
};

export interface IGetProjectCompanyOptionsProps extends IApiBaseProps {
  projectCompanyId: number;
}

export const getCheckerCompanyOptionsAsync = createGetOptionsFn<IProjectCompanyOption>(apiRoutes.checkerOptions);
export const getDesignerCompanyOptionsAsync = createGetOptionsFn<IProjectCompanyOption>(apiRoutes.designerOptions);
export const getReviewerCompanyOptionsAsync = createGetOptionsFn<IProjectCompanyOption>(apiRoutes.reviewerOptions);

export interface IGetCompanyDistributionOptionsProps extends IApiBaseProps {
  masterScheduleId: number;
}
export const getCompanyDistributionOptionsAsync = createGetOptionsCustomPropsFn<
  IProjectCompanyOption,
  IGetCompanyDistributionOptionsProps
>(apiRoutes.distributionOptions);

export const getAllProjectCompaniesWithRolesAndUsersAsync = async (
  props: IApiBaseProps,
): Promise<IPagedResultsV1<IProjectCompanyWithRolesAndAllUserTeam>> => {
  const result = await apiServerGet<IPagedResultsV1<IProjectCompanyWithRolesAndAllUserTeam>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.allCompaniesWithRolesAndUsers}`,
    {
      params: props,
    },
  );
  return result.data;
};
